import { SignoffConfigForStep } from '.';
import { makeRequest, CommonRequestOptions } from '../makeRequest';

export async function createTeamSignoffConfigForStep(
   stepId: number,
   teamId: number,
   common: CommonRequestOptions = {}
): Promise<SignoffConfigForStep> {
   return makeRequest('put', `/signoffs/${stepId}/signoff/${teamId}`, {
      ...common,
      body: {},
   });
}
